module.exports = __webpack_public_path__ + "static/media/nm.ee75b9a8.svg";